{
    "cl_header": {
      "logout": "Salir"
    },
    "cl_applauncher": {
      "seemoreapplications": "Ver más Aplicaciones",
      "spinner": "Cargando...",
      "noApps": "No hay aplicaciones disponibles"
    },
    "cl_alert": {
      "dismiss_all": "Desestimar todos",
      "notfication_title": "Notificaciones",
      "no_notifications": "Sin notificaciones"
    },
    "cl_side_nav": {
      "support": "Soporte",
      "legal": "Legal"
    },
    "cl_company_switcher": {
      "search_company": "Nombre de compañía",
      "loading": "cargando"
    },
    "applauncher": {
      "spinner": "Cargando..."
    }
  }